import React from "react";
import { RCCGrid, RCCIcon } from "react-common-components";
import { Link, useHistory } from "react-router-dom";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import Container from "./styles";

const PaneNotFound: React.FC = () => {
	const { translate } = useTranslation();
	const history = useHistory();
	return (
		<Container>
			<Title color="purple" size="xl" bold marginBottom={16}>
                404 - {translate("Página não encontrada")}
			</Title>
			<RCCGrid container item alignItems="center" justifyContent="center" style={{gap: "2rem"}}>
				<Title color="purple" size="sm" onClick={() => history.goBack()}>
					<RCCIcon name="arrowBack" style={{ marginRight: "0.125rem" }}/>
					{translate("Voltar")}
				</Title>
				<Link to="/">
					<Title color="purple" size="sm">
						<RCCIcon name="arrowBack" />
						<RCCIcon name="arrowBack" style={{ marginRight: "0.125rem" }}/>
						{translate("Voltar ao início")}
					</Title>
				</Link>
			</RCCGrid>
		</Container>
	);
};

export default PaneNotFound;
